import "./QuoteStateComponent.scss";
import template from "./QuoteStateComponent.html";
import {IComponentOptions} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";
import {BasisOfQuotations, TradingState} from "../../models/QuoteRecord";

export const QuoteState = "tfQuoteState";

export function quoteState(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<quote"
        },
        controllerAs: "ctrl",
        controller: QuoteStateComponentController
    };
}

export class QuoteStateComponentController {

    /** @input */
    public set model(model: QuoteViewModel | null) {
        if (model == null) {
            this.basisOfQuotations = [];
            this.tradingState = null;
            this.tradingStateClass = TradingState.OPEN;
            this.showTradingState = false;
        } else {
            this.basisOfQuotations = model.basisOfQuotation;
            this.tradingState = model.tradingState;
            this.tradingStateClass = this.stateClass(model.tradingState);
            this.showTradingState = model.tradingState !== TradingState.OPEN;
        }
    }

    public basisOfQuotations: BasisOfQuotations;
    public tradingState: TradingState | null;
    public tradingStateClass = "";
    public showTradingState = false;

    private stateClass(state: TradingState): string {
        switch (state) {
            case TradingState.PRE_OPEN:
                return "trading-state-pre-open";
            case TradingState.PRE_CSPA:
                return "trading-state-pre-cspa";
            case TradingState.OPENING:
                return "trading-state-opening";
            case TradingState.REG_HALT:
                return "trading-state-reg-halt";
            case TradingState.SUSPENDED:
                return "trading-state-suspended";
            case TradingState.CLOSED:
                return "trading-state-closed";
            default:
                return "";
        }
    }
}
